export default {
  Addcart(state, payload) {
    state.cart = payload;
  },
  getCartData(state, payload) {
    state.getCart = payload;
  },
};
